export const ReviewContent = {
  pageTitle: `Review your transfer request`,
  pageTitleGifting: `Great! Before continuing, review the gift request below`,
  subheader: `After selecting continue, you will not be able to make edits to the gift request so please review.`,
  continueButton: 'Continue',
  profileDescription: `If you have changes to your profile, you can update some of your information online by going to your <a class="link-underline" href="{{link}}">profile and account settings.</a>`,
  gifting: {
    fractionalSharesFAQ: {
      title: `How are fractional shares used in my gift?`,
      content: `By specifying a dollar amount and using specific identification (SpecID), we will use shares from the tax lots you have selected with a dollar amount for your gift. If you are gifting from a brokerage account, the value of the holdings you are gifting is determined by the closing price on the day preceding the day we process your gift. If you are gifting from a mutual fund account, the value of the holdings you are gifting is determined by the closing price on the day we process your gift. Please note, your accounts can’t hold a position of less than one full share.
        <br> <br> In some cases, additional fractional shares will be needed to complete your gift at the dollar value you have specified. In these instances, we will use the <strong>backup tax lot for fractional shares</strong> you have chosen to complete your gift request.`,
    },
    yearEndModal: {
      header: `Gifting Timing`,
      paragraphs: [
        `Your gift request will take 1-3 days to process and may not be completed until the following IRS tax-year.`,
      ],
    },
    giftAgainBtn: `Submit another gift`,
  },
  sharesDollarAmountLabel: `Est. shares/Est. dollar amount`,
  fundInvestWarning: `You could lose money by investing in the Fund. Although the Fund seeks to preserve the value of your investment at $1.00 per share, it cannot guarantee it will do so. An investment in the Fund is not a bank account and is not insured or guaranteed by the Federal Deposit Insurance Corporation or any other government agency. The Fund's sponsor is not required to reimburse the Fund for losses, and you should not expect that the sponsor will provide financial support to the Fund at any time, including periods of market stress.`,
  settlementFundDescription: `Your settlement fund (also known as a "sweep fund") is used to pay for investments and hold assets from investment sales and other transactions.`,
  internalSubmitButton: `Submit`,
  internalGiftingScript: [
    `Thank you [Mr./Mrs.] ________, let me quickly confirm your transfer details before I submit it to be processed.`,
    `You've requested to move the following positions (*read out each asset including NAME, COST BASIS METHOD, and corresponding SHARE or DOLLAR amount)`,
    `<strong>*If Spec ID</strong> read out share price, date acquired, and number of shares)`,
    `<strong>*IF GIFTING WITH DOLLARS:</strong> Please note, when you gift a dollar amount of an asset, the value is converted into shares and the share amount is what transfers to the gift recipient. There may be instances where the value of the shares being transferred, is different than the dollar amount you’ve requested. We’ll make our best effort to complete your gift as close to the requested dollar amount as possible.`,
    `<strong>*IF SPEC ID AND DOLLARS:</strong> If the share value is less than the intended gift value, we will pull from the tax lot: <ul><li>(Back up tax lot name)</li><li>Date acquired</li></ul>`,
    `This gift is coming from your (account type), numbered (XXXXXXX) and going to (recipient name’s) account numbered XXXXXX. The request should be completed in 1-3 business days, as long as there are no pending settlements into or out of the delivering account. You'll receive a confirmation once your request is complete.`,
    `One last thing to keep in mind: We can transfer fractional shares to another account. However, if that leaves less than a full share in the original account, those remaining fractional shares might be liquidated at the closing price on the day we process the transfer.`,
    `Once I submit your request, you may not be able to alter or cancel it. Do I have your permission to submit your request?`,
  ],
  inheritedIraTitle: 'Please review your application to open an account',
  expiredTransfer: `Your transfer has expired. Please submit another transfer request.`,
  receiptContent: {
    editButtonLabel: 'Edit',
    profileDescription: `If you have changes to your profile, you can update some of your information online by going to your <a class="link-underline" href="{{link}}">profile and account settings.</a>`,
    transferFromAndTo: {
      transferringFromLabel: 'Transferring from',
      transferringToLabel: 'Transferring to',
      accountTypeLabel: 'Account type',
      accountRegistrationLabel: 'Account registraiton',
      accountNumberLabel: 'Account number',
      accountNumberPendingLabel: 'Account number pending',
      dividendsAndCapitalGainsLabel: 'Dividends & capital gains',
      reinvestDistributions: 'Reinvest distributions',
      settlementFundLabel: 'Settlement fund',
      fundInvestWarning: `You could lose money by investing in the Fund. Although the Fund seeks to preserve the value of your investment at $1.00 per share, it cannot guarantee it will do so. An investment in the Fund is not a bank account and is not insured or guaranteed by the Federal Deposit Insurance Corporation or any other government agency. The Fund's sponsor is not required to reimburse the Fund for losses, and you should not expect that the sponsor will provide financial support to the Fund at any time, including periods of market stress.`,
      settlementFundDescription: `Your settlement fund (also known as a "sweep fund") is used to pay for investments and hold assets from investment sales and other transactions.`,
      learnMore: 'Learn more',
      close: 'Close',
    },
    openInheritedIraAccount: {
      originalAccountLabel: 'Original account info',
      previouslyInheritedLabel: 'Previously inherited',
      yes: 'Yes',
      no: 'No',
      iraTypeLabel: 'IRA Type',
      previouslyInheritedIraTypes: {
        nonRoth: 'Inherited IRA',
        roth: 'Inherited Roth IRA',
      },
      notPreviouslyInheritedIraTypes: {
        nonRoth: 'Traditional, Simple, or SEP IRA',
        roth: 'Roth IRA',
      },
      decedentNameLabel: `Decedent's name`,
      originalDecedentNameLabel: `Original decedent's name`,
      newAccountLabel: 'New account info',
      inheritedIRA: 'Inherited IRA',
      inheritedRothIRA: 'Inherited Roth IRA',
      sourceOfFunds: 'Source of funds',
      inheritance: 'Inheritance',
    },
    profile: {
      profileLabel: 'Profile',
      nameLabel: 'Name',
      emailLabel: 'Email',
      dateOfBirthLabel: 'Date of birth',
      citizenshipLabel: 'Citizenship',
      countryOfCitizenshipLabel: 'Country of citizenship',
      socialSecurityNoLabel: 'Social Security number',
      primaryResidenceLabel: 'Primary residence',
      mailingAddressLabel: 'Mailing address',
      primaryPhoneLabel: 'Primary phone',
      profileAccountSettingsLabel: '',
    },
    employment: {
      employmentLabel: 'Employment',
      employmentStatusLabel: 'Status',
      employerLabel: 'Employer',
      occupationLabel: 'Occupation',
      businessStreetAddressLabel: 'Business street address',
      companyNameLabel: 'Company name',
      natureOfBusinessLabel: 'Nature of business',
      spouseIsVgEmployeeLabel: 'Spouse is a Vanguard employee',
      associatedPersonLabel: 'Associated person',
      controlPersonLabel: 'Control person',
      yes: 'Yes',
      no: 'No',
    },
    financialProfile: {
      financialProfileLabel: 'Financial profile',
      investmentObjectiveLabel: 'Investment objective',
      incomeLabel: 'Income',
      netWorthLabel: 'Net worth',
    },
  },
};
